import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FinanceQA from './FinanceQA';
import LegalQA from './LegalQA';
import './Dashboard.css';

const API_URL = process.env.REACT_APP_API_URL || '';

const ASSISTANTS = [
  {
    key: 'finance',
    icon: '💰',
    name: '财务助手',
    desc: '基于CPA教材+中级教材+题库（10,908条向量），回答会计、审计、税法、财管等问题',
    available: true,
  },
  {
    key: 'legal',
    icon: '⚖️',
    name: '法务助手',
    desc: '基于法律法规+司法解释+案例知识库，以专业律师口吻提供法律咨询和分析',
    available: true,
  },
  // 后续可扩展：
  // { key: 'it', icon: '💻', name: 'IT助手', desc: '...', available: false },
];

export default function ProfessionalAssistant() {
  const navigate = useNavigate();
  const [activeKey, setActiveKey] = useState('legal');

  const active = ASSISTANTS.find(a => a.key === activeKey);

  return (
    <div className="knowledge-container">
      <div className="kb-browse-header">
        <button className="kb-back-btn" onClick={() => navigate('/knowledge')}>← 返回</button>
        <h2>🧑‍💼 专业助手</h2>
      </div>

      {/* 助手切换标签 */}
      <div className="qa-sources-list" style={{ marginBottom: 20, justifyContent: 'flex-start', gap: 12 }}>
        {ASSISTANTS.map(a => (
          <button
            key={a.key}
            className={`qa-source-tag${activeKey === a.key ? ' qa-badge-ai' : ''}`}
            onClick={() => a.available && setActiveKey(a.key)}
            disabled={!a.available}
            style={{
              cursor: a.available ? 'pointer' : 'not-allowed',
              opacity: a.available ? 1 : 0.5,
              fontSize: 14,
              padding: '6px 16px',
            }}
          >
            {a.icon} {a.name}{!a.available && '（开发中）'}
          </button>
        ))}
      </div>

      {/* 渲染对应助手 */}
      {activeKey === 'finance' && <FinanceQA embedded />}
      {activeKey === 'legal' && <LegalQA embedded />}
    </div>
  );
}
